import styled from '@emotion/styled'
export const StyleButtonWrapper = styled.div<any>`
  display: flex;
  ${(props) => props.styleButtonWrapper};
`
export const StyleButton = styled.button<any>`
  border-radius: ${(props) => props.radius || 6}px;
  border: ${(props) =>
    props?.border
      ? `1px solid ${props.theme.colors[props.border || 'primary']}`
      : props?.outline
        ? `1px solid ${props.theme.colors[props.bg || 'primary']}`
        : '0px'};
  width: ${(props) => (props?.width ? `${props?.width}px` : '100%')};
  height: ${(props) => (props?.height ? props?.height : 35)}px;
  background: ${(props) =>
    props?.outline
      ? 'transparent'
      : props.theme.colors[
          props.disabled ? 'secondary' : props.bg || 'primary'
        ]};
  padding: 0px 30px;
  font-size: 14px;
  color: ${(props) =>
    props?.outline
      ? props.theme.colors[props.bg || 'primary']
      : props.theme.colors[props?.tc || 'white']};
  ${(props) => props.styleButton};

  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`
